<template>
  <SimplifiedOnboardingModal v-model="open" @close="close" />
</template>

<script>
import SimplifiedOnboardingModal from '~/components/onboarding/SimplifiedOnboardingModal'
import { handleException } from '~/utils/exceptions'

export default {
  components: { SimplifiedOnboardingModal },
  data() {
    return {
      open: true,
    }
  },
  methods: {
    async close() {
      this.open = false
      await this.markUserAsOnboarded()
      await this.refreshToken()
      this.$emit('close')
    },
    markUserAsOnboarded() {
      return this.$axios
        .patch('/AUTH_URL/user', {
          onboarded: true,
        })
        .catch(handleException)
    },
    refreshToken() {
      return this.$store.dispatch('fiiAuth/refreshToken')
    },
  },
}
</script>
